import { IKeyStringAndValue } from "../../types/Types";

export const sortTable = (
  columnText: string,
  filteredData: Array<IKeyStringAndValue>,
  setFilteredData: React.Dispatch<
    React.SetStateAction<Array<IKeyStringAndValue>>
  >,
  arrowState: boolean | null,
  setCurrentPage: React.Dispatch<React.SetStateAction<number | string>>
) => {
  const compareValues = (a: IKeyStringAndValue, b: IKeyStringAndValue) => {
    if (!arrowState) {
      return b?.[columnText]
        .toLowerCase()
        .localeCompare(a?.[columnText].toLowerCase(), undefined, {
          numeric: true,
          sensitivity: "base",
        });
    } else {
      return a?.[columnText]
        .toLowerCase()
        .localeCompare(b?.[columnText].toLowerCase(), undefined, {
          numeric: true,
          sensitivity: "base",
        });
    }
  };

  const sortedNumbers = [...filteredData]
    .filter((a: IKeyStringAndValue) =>
      Number.isInteger(parseInt(a?.[columnText].charAt(0)))
    )
    .sort((a: IKeyStringAndValue, b: IKeyStringAndValue) => {
      return compareValues(a, b);
    });

  const sortedStrings = [...filteredData]
    .filter(
      (a: IKeyStringAndValue) =>
        !Number.isInteger(parseInt(a?.[columnText].charAt(0)))
    )
    .sort((a: IKeyStringAndValue, b: IKeyStringAndValue) => {
      return compareValues(a, b);
    });

  const sortedArray = arrowState
    ? sortedStrings.concat(sortedNumbers)
    : sortedNumbers.concat(sortedStrings);

  setFilteredData(sortedArray);
  setCurrentPage(1);
};
